import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Navbar from "../components/Navbar";
import BottomNav from "../components/BottomNav";
import SEO from "../components/SEO";
import CampaignRoom from "../components/CampaignRoom";
import api from "../lib/api";
import { Users, Megaphone, ArrowLeft } from "lucide-react";

export default function Groups() {
  const [params, setParams] = useSearchParams();
  const [data, setData] = useState(null);
  const active = params.get("room");
  useEffect(() => { const load = () => api.get("/groups").then((r) => setData(r.data)).catch(() => setData({ groups: [] })); load(); const t = setInterval(load, 10000); return () => clearInterval(t); }, [active]);
  const groups = data?.groups || [];
  const [kind, id] = (active || "").split(":");
  return (
    <div className="min-h-screen grain">
      <SEO title="Group chats" description="Your campaign and brand community group chats." path="/groups" noIndex />
      <Navbar />
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10 pt-24 pb-24" data-testid="groups-page">
        <div className="flex items-end justify-between gap-3 flex-wrap mb-6">
          <div><div className="text-xs uppercase tracking-[0.3em] text-zinc-500 mb-2 flex items-center gap-2"><Users className="h-4 w-4" /> Group chats</div>
            <h1 className="font-display font-bold text-3xl md:text-4xl tracking-tighter">Your crews, <span className="nexus-gradient-text">in one place.</span></h1></div>
          <Link to="/messages" className="text-xs text-zinc-400 hover:text-white underline underline-offset-4" data-testid="groups-to-direct">Direct messages →</Link>
        </div>
        <div className="grid md:grid-cols-[300px_1fr] gap-4">
          <div className={`space-y-2 ${active ? "hidden md:block" : ""}`} data-testid="groups-list">
            {data && groups.length === 0 && <div className="glass rounded-2xl p-6 text-sm text-zinc-500" data-testid="groups-empty">No groups yet. You'll join one automatically when you're accepted onto a campaign or into a brand's affiliate programme.</div>}
            {groups.map((g) => (
              <button key={g.key} onClick={() => setParams({ room: g.key })} className={`w-full text-left p-3 rounded-2xl border transition-colors ${active === g.key ? "bg-white/[0.06] border-nexus-pink/40" : "bg-[#0C0C10] border-white/10 hover:border-white/25"}`} data-testid={`group-${g.key}`}>
                <div className="flex items-center gap-2"><span className="h-8 w-8 rounded-xl bg-white/5 flex items-center justify-center shrink-0">{g.kind === "brand" ? <Users className="h-4 w-4 text-nexus-pink" /> : <Megaphone className="h-4 w-4 text-violet-300" />}</span>
                  <div className="min-w-0 flex-1"><div className="font-semibold text-sm truncate">{g.title}</div><div className="text-xs text-zinc-500 truncate">{g.last_message ? `${g.last_message.sender_name}: ${g.last_message.text}` : `${g.member_count} members · ${g.kind === "brand" ? "community" : "campaign"}`}</div></div>
                  {g.unread > 0 && <span className="text-[10px] font-bold px-2 py-0.5 rounded-full nexus-gradient text-white" data-testid={`group-unread-${g.key}`}>{g.unread}</span>}</div>
              </button>
            ))}
          </div>
          <div className={active ? "" : "hidden md:block"}>
            {active ? (<>
              <button onClick={() => setParams({})} className="md:hidden mb-3 text-xs text-zinc-400 flex items-center gap-1" data-testid="groups-back"><ArrowLeft className="h-3.5 w-3.5" /> All groups</button>
              <CampaignRoom key={active} tall showDenied campaignId={kind === "campaign" ? id : undefined} brandId={kind === "brand" ? id : undefined} />
            </>) : <div className="glass rounded-2xl p-10 text-center text-sm text-zinc-500">Pick a group to open the chat.</div>}
          </div>
        </div>
      </div>
      <BottomNav />
    </div>
  );
}
